import type { CarrierOption } from '../schemas/carriers';
import { locationDeliveriesFixtureCarrierIds } from './locationDeliveries';

// The carriers one building has been delivered at: the INTEGER id is what the deliveries filter
// sends, the name is a display label, and a building-wide read carries nothing else — no
// per-carrier counts, no dates, nothing recipient-adjacent.
// ⚠️ The `(#id)` suffix is requested, not confirmed, on this read (AS-041, CBX-11167).
const CARRIERS: CarrierOption[] = [
  { id: 4800, name: 'Amazon (#4800)' },
  { id: 5127, name: 'Amazon (#5127)' },
  { id: 1201, name: 'Correos' },
  { id: 1440, name: 'GLS' },
  { id: 1622, name: 'SEUR' },
];

// Buildings reserved for the two edge states. Both are addresses the search already returns
// («Calle Bolivia 39»), so one query puts the empty and the failed load side by side.
export const locationCarriersMockLocationIds = {
  empty: 4021,
  failing: 4022,
} as const;

export async function fetchLocationCarriersMock(locationId: number): Promise<CarrierOption[]> {
  // Simulate network latency for a realistic dev experience.
  await new Promise((resolve) => setTimeout(resolve, 100));
  if (locationId === locationCarriersMockLocationIds.failing) {
    throw new Error('location carriers unavailable');
  }
  if (locationId === locationCarriersMockLocationIds.empty) {
    return [];
  }
  // No option is a dead end: a carrier is offered only while rows stand behind it.
  return CARRIERS.filter((carrier) => locationDeliveriesFixtureCarrierIds.includes(carrier.id));
}
